import { useMutation, useQueryClient } from "@tanstack/react-query";

import { callLcosService } from "../../data/lcosServices";
import { useAccessControl } from "../../app/use-access-control";
import { useAccessToken } from "../use-access-token";
import { familyQueryKeys } from "./query-keys";
import { FamilyRole } from "./types";

export const useFamilyRoles = (familyId?: string) => {
  const { getToken } = useAccessToken();
  const { activeCenterId } = useAccessControl();
  const queryClient = useQueryClient();

  const addFamilyRoleMutator = useMutation({
    mutationFn: async (payload: FamilyRole) =>
      familyId && activeCenterId ? addFamilyRole(await getToken(), activeCenterId, familyId, payload) : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: familyQueryKeys.base });
    }
  });

  const removeFamilyRoleMutator = useMutation({
    mutationFn: async (payload: FamilyRole) =>
      familyId && activeCenterId ? removeFamilyRole(await getToken(), activeCenterId, familyId, payload) : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: familyQueryKeys.base });
    }
  });

  return {
    addFamilyRoleMutator,
    removeFamilyRoleMutator
  };
};

export const addFamilyRole = (accessToken: string, centerId: string, familyId: string, payload: FamilyRole) => {
  const modifiedPayload = {
    contact_id: payload.id,
    role_id: payload.role
  };

  return callLcosService<FamilyRole>(
    accessToken,
    `/api/centers/${centerId}/families/${familyId}/roles`,
    "POST",
    modifiedPayload
  );
};

export const removeFamilyRole = (accessToken: string, centerId: string, familyId: string, payload: FamilyRole) => {
  return callLcosService<{}>(accessToken, `/api/centers/${centerId}/families/${familyId}/roles`, "DELETE", {
    contact_id: payload.id,
    role_id: payload.role
  });
};
